import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Button
} from '@material-ui/core';

import {
    Alert
} from '@material-ui/lab';

import { PageContext } from '../PageContext';

import { LicenseStatus } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {},
    alert: {
        marginBottom: theme.spacing(1)
    }
}));

export const ConfigStatus = ({ ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        license,
        configStatus,
        configHasChanges,
        errors
    } = state;

    const buyLicenseClickHandler = (e) => {
        const buyUrl = `https://eshop.teamonair.com/eshop`;
        window.open(buyUrl, "_blank");
    }

    return (
        <div className={clsx(classes.root, props.className)}>

            {license.status !== LicenseStatus.Active &&
                <Alert
                    className={classes.alert}
                    variant="outlined"
                    severity="warning"
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            onClick={buyLicenseClickHandler}>
                            {t("ButtonBuyLicense")}
                        </Button>
                    }>
                    {t("LabelLicenseNotFound")}
                </Alert>
            }

            {configHasChanges &&
                <Alert className={classes.alert} variant="outlined" severity="warning">
                    {t("LabelChangesAreMade")}
                </Alert>
            }

            {!configStatus.isLiveConfigUpdated &&
                <Alert className={classes.alert} variant="outlined" severity="info">
                    {t("LabelLiveConfigNotUpdated")}
                </Alert>
            }

            {!configStatus.isAppConfigUpdated &&
                <Alert className={classes.alert} variant="outlined" severity="info">
                    {t("LabelAppConfigNotUpdated")}
                </Alert>
            }

        </div>
    );
}